import { find, isNil } from "lodash";
import { AICC_PROMPT_DEFAULT_EFFORT } from "constants/aiccPrompt";
import { AiccPromptConfig, AiccPromptModel } from "types/model/aiccPrompt";
import { SaveAiccPromptRequest } from "types/dto/request/aiccPrompt";

// 🔴 Only changed fields: one model record drives several prompts, and a full payload overwrote the others.
// 🔴 No `expected_updated_at`: AICC2-328 wants last write wins, and sending it turns the second save into a 409.
export function saveRequest(draft: AiccPromptConfig, saved: AiccPromptConfig): SaveAiccPromptRequest {
  const payload: SaveAiccPromptRequest = {};

  if (draft.promptText !== saved.promptText) {
    payload.prompt_text = draft.promptText;
  }
  if (draft.modelId !== saved.modelId && draft.modelId) {
    payload.model_id = draft.modelId;
  }
  if (draft.temperature !== saved.temperature && !isNil(draft.temperature)) {
    payload.temperature = draft.temperature;
  }
  if (draft.reasoningEffort !== saved.reasoningEffort) {
    // 🔴 null, not absent: moving to a model without reasoning has to clear the previous effort.
    payload.llm_reasoning_effort = draft.reasoningEffort ?? null;
  }

  return payload;
}

// 🔴 An effort the model does not list is a 400; left undefined, the select showed a placeholder and Save sent null.
const defaultEffort = (efforts: string[]) => {
  if (!efforts.length) {
    return undefined;
  }

  return efforts.includes(AICC_PROMPT_DEFAULT_EFFORT) ? AICC_PROMPT_DEFAULT_EFFORT : efforts[0];
};

export function changeModel(draft: AiccPromptConfig, models: AiccPromptModel[], modelId: string): AiccPromptConfig {
  const efforts = find(models, { id: modelId })?.efforts ?? [];
  const keepsEffort = !!draft.reasoningEffort && efforts.includes(draft.reasoningEffort);

  return { ...draft, modelId, reasoningEffort: keepsEffort ? draft.reasoningEffort : defaultEffort(efforts) };
}
